var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageBlast = function SvgMessageBlast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2275 42.1336V28.7445C42.2275 24.7686 38.9746 21.5156 34.9987 21.5156H8.98859C5.01271 21.5156 1.75977 24.7686 1.75977 28.7445V50.7071C1.75977 54.6829 5.01271 57.9359 8.98859 57.9359H21.1647C22.2855 57.9359 23.194 58.8446 23.194 59.9652V65.3453C23.194 66.3998 24.5193 66.8687 25.1826 66.0491L31.0193 58.8352C31.4794 58.2666 32.1719 57.9361 32.9035 57.9361H34.9987C38.9746 57.9361 42.2275 54.6831 42.2275 50.7072V41.3292",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2277 17.1336V8.74445C66.2277 4.76857 62.9748 1.51562 58.9989 1.51562H32.9888C29.945 1.51562 27.3248 3.42219 26.2637 6.1001M66.2277 16.3292V30.7072C66.2277 33.9896 64.0106 36.7793 61 37.6526",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7238 27.138V18.7488C54.7238 14.773 51.4709 11.52 47.495 11.52H21.4849C18.4411 11.52 15.8209 13.4266 14.7598 16.1045M54.7238 26.3336V40.7116C54.7238 43.994 52.5067 46.7837 49.4961 47.657",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8789 34.3459C17.8789 32.0011 19.7798 30.1002 22.1246 30.1002C24.4694 30.1002 26.3703 32.0011 26.3703 34.3459C26.3703 36.6907 24.4694 38.5916 22.1246 38.5916C19.7798 38.5916 17.8789 36.6907 17.8789 34.3459Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6994 44.7153C28.973 41.2185 25.8808 38.5915 22.1764 38.5915H22.073C18.3686 38.5915 15.2765 41.2185 14.5501 44.7153C14.0078 47.3254 17.9546 48.1001 22.1764 48.1001C26.3982 48.1001 30.2417 47.3254 29.6994 44.7153Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMessageBlast;